import(/* webpackMode: "eager" */ "/root/enhanci-frontend/app/privacy-policy/page.tsx")